import { LabelLangString } from "component/LabelLang/label-lang";
// import { API_BASE_URL } from "configs/AppConfig";
import Modal from "react-bootstrap/Modal";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const FilesModal = ({
  show,
  handleClose,
  files,
  type,
  fileUrl = null,
  publicationName,
  studyPeriod,
  onExport,
}) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const dir = useSelector(({ theme }) => theme.direction);

  // let intl = useIntl();

  return (
    <div className="files-modal">
      <Modal
        style={{ zIndex: "9999999999", direction: dir }}
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header style={{ padding: "1rem" }} closeButton>
          <Modal.Title className="w-100">
            <FormattedMessage id="publication-files" />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "1.5rem" }}>
          <div className="row d-flex gy-4">
            {fileUrl && (
              <div className="col-12">
                <div className="container-file">
                  {/* <a
                                href={`${API_BASE_URL}/${fileUrl}`}
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex align-items-center gap-3"
                                style={{width: "fit-content"}}
                            >
                                <img
                                    loading="lazy"
                                    src={process.env.PUBLIC_URL + `${fileUrl.toLowerCase().includes('.excel') ? '/image/Excel.svg' : '/image/pdf.png'}`}
                                    alt={`${publicationName} / ${intl.formatMessage({ id: "unnamed-file"})}`}
                                    height="35"
                                />
                                <h6 className="text-black fw-semibold mb-0">
                                    {`${publicationName} / ${intl.formatMessage({ id: "unnamed-file"})}`}
                                </h6>
                            </a> */}
                  <button
                    className="d-flex"
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    onClick={() =>
                      onExport(
                        type === 1 ? "EXCEL" : "PDF",
                        `${fileUrl}`,
                        `${publicationName}`
                      )
                    }
                  >
                    <img
                      loading="lazy"
                      src={
                        process.env.PUBLIC_URL +
                        `${type === 1 ? "/image/Excel.svg" : "/image/pdf.png"}`
                      }
                      alt={`${publicationName}`}
                      height="35"
                      className="px-3"
                    />
                    <h6 className="text-black fw-semibold mb-0">
                      {`${publicationName}`}
                    </h6>
                  </button>
                </div>
              </div>
            )}
            {files.map((el) => (
              <div key={el.id} className="col-12">
                <div className="container-file">
                  {/* <a
                    href={`${API_BASE_URL}/${LabelLangString({
                      id: "fileUrl",
                      currentLocale: currentLocale,
                      defaultValue: el.fileUrl,
                      translations: el.publicationDetailsFilesTranslation,
                    })}`}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-center gap-3"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      loading="lazy"
                      src={
                        process.env.PUBLIC_URL +
                        `${type === 1 ? "/image/Excel.svg" : "/image/pdf.png"}`
                      }
                      alt={el.name}
                      height="35"
                    />
                    <h6 className="text-black fw-semibold mb-0">
                      {`${publicationName} / ${
                        el.name ? (
                          LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: el.name,
                            translations: el.publicationDetailsFilesTranslation,
                          })
                        ) : (
                          <FormattedMessage id="un-named" />
                        )
                      }`}
                    </h6>
                  </a> */}
                  <button
                    className="d-flex"
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    onClick={() =>
                      onExport(
                        type === 1 ? "EXCEL" : "PDF",
                        `${LabelLangString({
                          id: "fileUrl",
                          currentLocale: currentLocale,
                          defaultValue: el.fileUrl,
                          translations: el.publicationDetailsFilesTranslation,
                        })}`.substring(1),
                        `${publicationName} / ${
                          el.name ? (
                            LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: el.name,
                              translations:
                                el.publicationDetailsFilesTranslation,
                            })
                          ) : (
                            <FormattedMessage id="un-named" />
                          )
                        }`
                      )
                    }
                  >
                    <img
                      loading="lazy"
                      src={
                        process.env.PUBLIC_URL +
                        `${type === 1 ? "/image/Excel.svg" : "/image/pdf.png"}`
                      }
                      alt={`${publicationName}`}
                      height="35"
                      className="px-3"
                    />
                    <h6 className="text-black fw-semibold mb-0">
                      {`${publicationName} / ${
                        el.name ? (
                          LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: el.name,
                            translations: el.publicationDetailsFilesTranslation,
                          })
                        ) : (
                          <FormattedMessage id="un-named" />
                        )
                      }`}
                    </h6>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FilesModal;
